import { CirclePreloader } from '@components/preloader';

export function DefaultLoader() {
  return <CirclePreloader contrast />;
}
